<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-11-16 09:01:05
 * @LastEditTime: 2024-08-21 09:25:44
 * @LastEditors: xz
-->
<template>
  <el-menu :default-active="$route.path" route class="el-menu-demo" mode="horizontal" @select="handleSelect"
    text-color="#fff" active-text-color="#ffd04b" background-color="#031131">
    <el-menu-item disabled>
      <span style="color: #fff !important">
        <img src="../../../static/tscon.png" alt="" class="image" />
        YX-WRQ知识图谱平台
      </span>
    </el-menu-item>
    <el-menu-item index="/">
      <i class="el-icon-s-home"></i>首页
    </el-menu-item>
    <el-submenu index="/tupu">
      <template slot="title">
        <i class="iconfont  icon-qiyetupu" style="margin-right: 5px"></i>知识图谱
      </template>
      <el-menu-item index="/tupu">
        <i class="iconfont  icon-qiyetupu" style="margin:0 7px"></i>yx图谱
      </el-menu-item>
      <el-menu-item index="/ReportNewW">
        <i class="el-icon-s-order"></i>报告生成
      </el-menu-item>
      <el-menu-item index="/flowcount">
        <i class="el-icon-s-data"></i>流量计算
      </el-menu-item>
    </el-submenu>
    <el-submenu index="/de">
      <template slot="title">
        <i class="el-icon-search"></i>智能检索</template>
      <el-menu-item index="/de">
        <i class="el-icon-view"></i>信息查看
      </el-menu-item>
      <el-menu-item index="/search">
        <i class="el-icon-paperclip"></i>图文检索
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="/float">
      <i class="el-icon-pie-chart"></i>浮漂监测
    </el-menu-item>
    <el-menu-item index="/file">
      <i class="el-icon-folder-opened"></i>资料管理
    </el-menu-item>
    <el-submenu index="http://122.152.198.146:9991/">
      <template slot="title"><i class="el-icon-setting"></i>系统管理</template>
      <el-menu-item index="http://122.152.198.146:9991/">
        <i class="el-icon-news"></i>知识标注
      </el-menu-item>
      <el-menu-item index="/dataSource">
        <i class="el-icon-news"></i>数据源配置
      </el-menu-item>
    </el-submenu>

    <!-- <el-menu-item index="/de">
      <i class="el-icon-view"></i>信息查看
    </el-menu-item> -->
    <!-- <el-menu-item index="/tupu">
      <i class="el-icon-share"></i>知识图谱</el-menu-item> -->
    <!-- <el-menu-item index="/flowcount"> -->
    <!-- <i class="el-icon-s-data"></i>流量计算</el-menu-item> -->
    <!-- <el-menu-item index="/Report"> -->
    <!-- <el-menu-item index="/ReportNewW">
      <i class="el-icon-s-order"></i>报告生成
    </el-menu-item> -->
    <!-- <el-menu-item index="/search">
      <i class="el-icon-share"></i>图文检索</el-menu-item> -->

    <!--  window.open("http://122.152.198.146:9991/"); -->
    <!-- <el-menu-item index="http://122.152.198.146:9991/">
      <i class="el-icon-news"></i>知识标注</el-menu-item> -->

    <!-- <el-menu-item index="/neo4j">
            <i class="el-icon-news"></i>数据库</el-menu-item> -->
    <!-- <el-menu-item index="/dataSource">
      <i class="el-icon-news"></i>数据源配置</el-menu-item> -->
    <div class="user">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <el-avatar :src="require('../../../static/user.jpg')"></el-avatar>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="user">查看用户</el-dropdown-item>
          <el-dropdown-item command="editPwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          <!-- <el-dropdown-item command="a"></el-dropdown-item>
          <el-dropdown-item command="b">狮子头</el-dropdown-item>
          <el-dropdown-item command="c">螺蛳粉</el-dropdown-item>
          <el-dropdown-item command="d" disabled>双皮奶</el-dropdown-item>
          <el-dropdown-item command="e" divided>蚵仔煎</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="" :visible.sync="userShow" width="30%" :before-close="handleClose">
      <div class="user-info">
        <!-- <img :src="require('../../../static/user.jpg')" class="avatar"> -->
        <div class="info">
          <p class="title">姓名：</p>
          <p class="content">{{ userInform.name }}</p>
        </div>
        <div class="info">
          <p class="title">电话号码：</p>
          <p class="content">{{ userInform.mobile }}</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="pwdShow" width="30%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="c_name">
          <el-input v-model="ruleForm.c_name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="c_mobile">
          <el-input v-model="ruleForm.c_mobile"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="c_password">
          <el-input v-model="ruleForm.c_password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdShow = false">取 消</el-button>
        <el-button type="primary" @click="toChangePassword('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>
<script>
import userApi from "@/api/user";
import md5 from "js-md5";
export default {
  components: {},

  data() {
    return {
      dialogVisible: false,
      userShow: false,
      pwdShow: false,
      ruleForm: {
        c_mobile: '',
        c_name: '',
        c_password: '',

      },
      formRules: {
        c_name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        c_mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
        ],
        c_password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      // add by zhouao 2023/12/05 start
      userInform: {
        name: "",
        mobile: ""
      },
      // add by zhouao 2023/12/05 end
    };
  },
  watch: {
    '$route': {
      deep: true,
      immediate: true,
      handler: (newValue) => {
        //console.log("newValue", newValue);
        this.activeIndex = newValue.path
      }
    }
  },
  methods: {
    handleClose(done) {
      done();
    },
    // add by zhouao 2023/12/05 start
    getUserInform() {
      userApi.getUserByToken().then((res) => {
        if (res.data.code === 200) {
          this.userInform.name = res.data.data.c_name
          this.userInform.mobile = res.data.data.c_mobile
        }
      })
    },
    // add by zhouao 2023/12/05 end
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      if (key && key.includes("http")) {
        window.open(key);
      } else if (key == "de") {
        this.$router.push(`/de`);
      } else {
        this.$router.push(key);
      }
    },
    handleCommand(data) {
      //console.log("data", data);
      if (data == "login") {
        this.$router.push("/login");
      } else if (data == "logout") {
        sessionStorage.removeItem("token");
        this.$router.push("/login");
      } else if (data == 'user') {
        this.getUserInform()
        this.userShow = true
      } else if (data == 'editPwd') {
        this.ruleForm = {
          c_mobile: '',
          c_name: '',
          c_password: '',

        }
        this.pwdShow = true
      }
    },
    toChangePassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          userApi
            .resetPassword({
              c_name: this.ruleForm.c_name,
              c_mobile: this.ruleForm.c_mobile,
              c_password: md5(this.ruleForm.c_password),
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '密码设置成功',
                  type: 'success'
                })
                this.pwdShow = false;
              } else {
                this.$message({
                  message: '密码设置失败',
                  type: 'error'
                })
              }
            })
        } else {
          this.$message({
            message: '请填写内容',
            type: 'info'
          })
          console.log('error submit!!');
          return false;
        }
      })
    },
  }
};
</script>

<style scoped>
.el-menu-demo {
  width: 100vw;
  position: relative;
  background: linear-gradient(144deg,
      rgb(6, 42, 102) 0%,
      rgb(4, 14, 36) 15%,
      rgb(2, 17, 51) 68%,
      rgb(71, 32, 72) 100%);
}

.image {
  width: 30px;
  height: 30px;
  /* box-shadow: 8px 16px 16px hsl(0deg 0% 0%/0.25); */
}

.el-menu-demo /deep/ .is-disabled {
  opacity: 1 !important;
  font-size: 20px;
}

.user {
  height: 100%;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-25%);
}

li:hover {
  background: transparent !important;
}

li:active {
  background: transparent !important;
}

li::before {
  background: transparent !important;
}

li:active::before {
  background: transparent !important;
}

.user-info {
  margin-left: 5%;
}

.info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.title {
  /* width: 100px; */
  font-size: 14px;
  /* font-weight: bold; */
}

.content {
  width: 70%;
  font-size: 14px;
  color: rgb(77, 76, 76);
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/index.vue